// @ts-nocheck
import React, { useState, useEffect, useMemo, lazy, Suspense } from "react";
import { PageContainer } from "../components/AssetBreadCrumb";
import OrganizationPreview from "../components/Organization/OrganizationPreview";
import { ReactComponent as GroupIcon } from "../assets/icons/group-icon.svg";
import { ReactComponent as MapIcon } from "../assets/icons/map-02.svg";
import { ReactComponent as GlobeIcon } from "../assets/icons/globe-02.svg";
import { ReactComponent as ListIcon } from "../assets/icons/list-icon.svg";
import { ReactComponent as DashboardIcon } from "../assets/icons/layout-alt-01.svg";
import { ReactComponent as LayersIcon } from "../assets/icons/layers-icon.svg";
import { ReactComponent as PlusIcon } from "../assets/icons/plus.svg";
import { ReactComponent as ChevronUpIcon } from "../assets/icons/chevron-up.svg";
import { ReactComponent as ChevronDownIcon } from "../assets/icons/chevron-down.svg";
import bgpattern from "../assets/images/bg-pattern-01.svg";
import { AssetGrid, AssetCardSkeleton } from "../components/AssetCard";
import FilterBar, { FilterBarSkeleton } from "../components/ReusableComponents/FilterBar";
import { Skeleton, SkeletonGroup } from "../components/Skeleton";
import { getOwnerFromId, filterAssets, ENERGY_MODEL_FILTERS } from "../util/utils";
import AssetMapView from "../components/AssetMapView/AssetMapView";
import { useDispatch, useSelector } from "react-redux";
import { setModalState, modalViewsConst } from "../store/modalSlice";
import { fetchAssetsByGroupId, selectTotalAssetCount } from "../store/assetsSlice";
import { useParams, useNavigate, Link } from "react-router-dom";
import { fetchAuthSession } from "aws-amplify/auth";
import { checkAssetLimit } from "../api/stripeSubscription";
import { fetchSubscriptionStatus, selectSubscriptionStatus } from "../store/userSlice";
import { imageCache } from "../utils/imageCache";
import ProcessedModelManagement from "../components/ProcessedModelManagement/ProcessedModelManagement";
import { useTour } from "../components/Tour/TourProvider";
import useMediaQuery from "../hooks/useMediaQuery";

// Lazy, so the map library is only downloaded by someone who opens the overview
const GroupOverviewMap = lazy(() => import("../components/GroupOverviewMap"));

// The switchable views; models is admin-only and offered from the list view alone
const VIEW_OPTIONS = [
  { id: "list", label: "List View", Icon: ListIcon, title: "Switch to List View" },
  { id: "map", label: "Map View", Icon: MapIcon, title: "Switch to Map View" },
  { id: "overview", label: "Overview", Icon: GlobeIcon, title: "Switch to System Overview", adminOnly: true },
  { id: "dashboard", label: "Dashboard", Icon: DashboardIcon, title: "Switch to Dashboard View", adminOnly: true },
];

const GroupPage = (props) => {
  let { groupid } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [viewMode, setViewMode] = useState("list"); // "list", "map", "dashboard", or "models"
  // Tailwind's sm. The masthead puts the New Asset button in a different row either side of it, so it is chosen by breakpoint here rather than shown and hidden with CSS, which would leave two buttons in the page (the tour spotlights the first one it finds).
  const isSmUp = useMediaQuery("(min-width: 640px)");
  const [imageError, setImageError] = useState(false);
  const [profilePicUrl, setProfilePicUrl] = useState(null);
  const [selectedParams, setSelectedParams] = useState(new Set(['waterLevel', 'flowRate', 'temperature']));
  const [updatesCollapsed, setUpdatesCollapsed] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [ownerFilter, setOwnerFilter] = useState("");
  const [energyModelFilter, setEnergyModelFilter] = useState("");
  const [ownerNames, setOwnerNames] = useState({});

  const assets = useSelector(state => state.assets);
  const assetGroups = useSelector(state => state.assetGroups);
  const user = useSelector(state => state.user);

  // Craig Put DYNAMIC DATA Here Watch the modal state to handle asset creation/updates
  const modalState = useSelector((state) => state.modalState);
  const totalAssetCount = useSelector(selectTotalAssetCount);
  const subscriptionStatus = useSelector(selectSubscriptionStatus);

  useEffect(() => {
    // error handling here
    if (!assets.dataGroups[groupid]) {
      dispatch(fetchAssetsByGroupId(groupid));
    }
    // Reset image error state when group changes
    setImageError(false);
    setProfilePicUrl(null);
  }, [groupid]);

  // Prefetch the subscription tier on mount so the asset-limit check is instant on click (no fetch lag). Shared, deduped Redux cache — fail open (null) while loading or after a failed read.
  useEffect(() => {
    dispatch(fetchSubscriptionStatus());
  }, [dispatch]);

  const toggleParam = (paramId) => {
    setSelectedParams(prev => {
      const newSet = new Set(prev);
      if (newSet.has(paramId)) {
        newSet.delete(paramId);
      } else {
        newSet.add(paramId);
      }
      return newSet;
    });
  };
  
  // React to successful asset creation/editing by refreshing asset list Craig, this is a good example of callback, but don't need it atm useEffect(() => { // Only proceed if modal was just closed (modalOpen changed from true to false) if (!modalState.modalOpen && modalState.lastResult) { console.log('Modal was closed with result:', modalState.lastResult);
      
  // // Check if the result indicates success for an asset operation if (modalState.lastResult.success && (modalState.lastResult.action === 'create' || modalState.lastResult.action === 'update')) { // Get the most recent asset data for this group dispatch(fetchAssetsByGroupId(groupid)); }
      
  // // No need to clear the lastResult as it will be overwritten on next modal close } }, [modalState.modalOpen]);

  const handleAddAsset = async () => {
    const authSession = await fetchAuthSession();
    const groups =
      authSession?.tokens?.idToken?.payload?.["cognito:groups"] ?? [];
    const isAdmin = groups?.includes("Admin");

    // Admins are exempt; everyone else is capped by their subscription tier (same check as chat).
    if (!isAdmin) {
      // Uses the prefetched subscriptionStatus — null while loading or on fetch failure means fail open.
      if (subscriptionStatus) {
        const check = checkAssetLimit(subscriptionStatus, totalAssetCount, 1);
        if (!check.allowed) {
          dispatch(
            setModalState({
              modalOpen: true,
              modalView: modalViewsConst.assetLimitReached,
              properties: {
                __modalSize: "xs",
                tier: check.tier,
                limit: check.limit,
                currentCount: check.currentCount,
                source: "group_page_add_asset",
              },
            })
          );
          return;
        }
      }
    }

    dispatch(
      setModalState({
        modalOpen: true,
        modalView: modalViewsConst.addAssetNEW,
        properties: { __modalSize: "md", assetGroupId: groupid }
      })
    );

    // setDialogueOpen(false);
  };
  // const handleAddAsset = () => { let assetCount = 0; Object.values(assets.dataGroups).forEach( (groupAssetList) => (assetCount += groupAssetList.length) ); if (assetCount > 9) { dispatch( setModalState({ modalOpen: true, modalView: modalViewsConst.notification, properties: { header: "Quick Note", details: "Assets are currently being capped at 10 per user. Please reach out to support@erode.ai for any inquiries", }, }) ); } else { dispatch( setModalState({ modalOpen: true, modalView: modalViewsConst.addAssetNEW, properties: { assetGroupId: groupid }, }) ); } };

  const selectedGroup = assetGroups.groups[groupid];

  const isAdmin = user?.details?.groups?.includes("Admin");

  // Org-owned groups only take new assets from an admin or the group owner
  const canAddAsset = !(
    selectedGroup?.organizationId &&
    !isAdmin &&
    selectedGroup?.owner !== user.permissionDetails?.id
  );

  // First visit to a Group page: run the one-time blurred guide once data is loaded (so the anchors exist). Skipped if another tour is active or the flag is set. Stable pieces only — depending on the whole context re-fires this on every tour step.
  const { activeTour, hasFlag, start, flagsReady } = useTour();
  const groupDataLoaded = Boolean(assets.dataGroups[groupid]);
  useEffect(() => {
    if (!selectedGroup || !groupDataLoaded || !flagsReady) return;
    if (activeTour || hasFlag("groupTourSeen")) return;
    start("group");
  }, [selectedGroup, groupDataLoaded, flagsReady, activeTour, hasFlag, start]);

  // Fetch the signed URL for the profile picture using cache
  useEffect(() => {
    const fetchProfilePic = async () => {
      if (selectedGroup?.profilePictureUrl) {
        // Clear a previous failure so a freshly uploaded image isn't stuck on the fallback icon
        setImageError(false);
        try {
          const cachedUrl = await imageCache.getSignedUrl(selectedGroup.profilePictureUrl);
          if (cachedUrl) {
            setProfilePicUrl(cachedUrl);
          } else {
            setImageError(true);
          }
        } catch (error) {
          console.error('Error fetching profile picture URL:', error);
          setImageError(true);
        }
      }
    };

    fetchProfilePic();
  }, [selectedGroup?.profilePictureUrl]);

  const groupAssets = assets.dataGroups[groupid];

  // Owner names back the Owner select and let search match on a person's name, not just an id
  useEffect(() => {
    const fetchOwnerNames = async () => {
      const ids = [...new Set((groupAssets || []).map((asset) => asset.owner).filter(Boolean))];
      const entries = await Promise.all(
        ids.map(async (id) => {
          try {
            const owner = await getOwnerFromId(id);
            return [id, owner?.name || owner?.username || "Unknown User"];
          } catch (error) {
            console.error("Error fetching owner details:", error);
            return [id, "Unknown User"];
          }
        })
      );
      setOwnerNames(Object.fromEntries(entries));
    };

    fetchOwnerNames();
  }, [groupAssets]);

  const filteredAssets = useMemo(
    () =>
      filterAssets({
        assets: groupAssets || [],
        searchTerm: searchValue,
        ownerId: ownerFilter,
        energyModel: energyModelFilter,
        ownerNames,
      }),
    [groupAssets, searchValue, ownerFilter, energyModelFilter, ownerNames]
  );

  // Built from the assets themselves, so a filter never offers an empty result
  const ownerOptions = useMemo(
    () =>
      [...new Set((groupAssets || []).map((asset) => asset.owner).filter(Boolean))]
        .map((id) => ({ value: id, label: ownerNames[id] || "Unknown User" }))
        .sort((a, b) => a.label.localeCompare(b.label)),
    [groupAssets, ownerNames]
  );

  const energyModelOptions = useMemo(() => {
    const present = ENERGY_MODEL_FILTERS.filter(({ field }) =>
      (groupAssets || []).some((asset) => asset[field])
    ).map(({ value, label }) => ({ value, label }));

    const hasUnmodelled = (groupAssets || []).some((asset) =>
      ENERGY_MODEL_FILTERS.every(({ field }) => !asset[field])
    );

    return hasUnmodelled ? [...present, { value: "none", label: "No model" }] : present;
  }, [groupAssets]);

  if (
    !assets.dataGroups[groupid] ||
    // assets.dataGroups[groupid].length === 0 ||
    !assetGroups.groups[groupid]
  ) {
    // Placeholders in the real layout rather than a spinner, so the page lands in place
    return (
      <PageContainer>
        <div className="w-full">
          <div className="eai-gap-header flex flex-col gap-5">
            <div className="flex items-center gap-5">
              <Skeleton className="h-[88px] w-[88px] shrink-0 rounded-eai-card sm:h-28 sm:w-28" radius="none" />
              <div className="min-w-0 flex-1">
                <Skeleton className="h-3 w-28" />
                <Skeleton className="mt-2 h-7 w-2/3 max-w-sm" />
                <Skeleton className="mt-2.5 h-3 w-1/2 max-w-xs" />
              </div>
            </div>
            <div className="flex flex-wrap items-center justify-end gap-2">
              <Skeleton className="h-eai-control-lg w-40" radius="md" />
              <Skeleton className="h-eai-control-lg w-32" radius="md" />
            </div>
          </div>

          <FilterBarSkeleton filters={2} />

          <div className="eai-section-label flex items-center gap-2.5">
            <Skeleton className="h-3 w-20" />
            <span className="h-px flex-1 bg-eai-border" />
          </div>

          <SkeletonGroup count={6} label="Loading assets" className="eai-card-grid">
            <AssetCardSkeleton />
          </SkeletonGroup>
        </div>
      </PageContainer>
    );
  }

  const organization = user.organizations?.data?.[selectedGroup?.organizationId]

  const hasGroupImage = Boolean(profilePicUrl) && !imageError;
  const assetCount = groupAssets?.length ?? 0;

  // The views the segmented control offers. Manage Models is a view too, but an admin-only one reached from the list, so it stays out of the segment rather than appearing and disappearing from it.
  const availableViews = VIEW_OPTIONS.filter((view) => !view.adminOnly || isAdmin);

  // One switch, two homes: the masthead, and the overview, which has no masthead. There it sits among the map's controls, so compact sets it as one of them: icons alone, at their height, lifted off the map as they are.
  const renderViewSwitcher = (compact = false) => (
    <div
      data-tour="group-view-toggle"
      className={`eai-seg ${compact ? "h-eai-control-sm shadow-eai-card" : ""}`}
    >
      {availableViews.map(({ id, label, Icon, title }) => {
        const active = id === viewMode;
        return (
          <button
            key={id}
            onClick={() => setViewMode(id)}
            className={`eai-seg-item ${compact ? "px-2.5" : ""} ${active ? "eai-seg-item-active" : ""}`}
            type="button"
            aria-current={active ? "page" : undefined}
            /* The label is hidden below sm, so the button needs its own name there */
            aria-label={label}
            title={title}
          >
            <Icon className="h-4 w-4 shrink-0 [&_path]:stroke-current" />
            {!compact && <span className="hidden sm:inline">{label}</span>}
          </button>
        );
      })}
    </div>
  );

  // One New Asset button, placed by breakpoint: from sm up it pins right of the title, below sm it joins the view controls, where the title has no room to share.
  const addAssetButton = (
    <button
      onClick={handleAddAsset}
      data-tour="group-add-asset"
      className="eai-btn-cta eai-btn-icon-mobile shrink-0"
      type="button"
      disabled={!canAddAsset}
      aria-label="New Asset"
      title={
        canAddAsset
          ? "New Asset"
          : "Only admins and group owners can add assets to organization groups"
      }
    >
      <PlusIcon className="h-4 w-4 shrink-0" />
      <span className="hidden sm:inline">New Asset</span>
    </button>
  );

  // Page masthead: round group portrait left, identity right, members and view controls on a bottom row. The group's name is the page's h1 — the old header made every group's h1 the words "Asset Group" and pushed the real identity into a tile below it.
  const groupMasthead = (
    <div className="eai-gap-header">
      <div className="flex flex-col gap-5">
        <div className="flex items-center gap-5">
          <div
            className="eai-media h-[88px] w-[88px] shrink-0 sm:h-28 sm:w-28"
            style={{
              backgroundImage: hasGroupImage ? `url(${profilePicUrl})` : `url(${bgpattern})`,
            }}
          >
            {/* Without a picture the portrait is just the pattern — badge it so it still reads as a group */}
            {!hasGroupImage && (
              <div className="flex h-full w-full items-center justify-center">
                <GroupIcon className="h-8 w-8" />
              </div>
            )}
          </div>

          <div className="min-w-0 flex-1">
            {/* Same eyebrow as the list pages' PageHeader, doubling as the way back up to all groups. No count pill — the "N Assets" section label below already carries it. */}
            <Link
              to="/home"
              title="Back to all groups"
              className="group inline-flex items-center"
            >
              <span className="eai-slash mr-1.5 text-sm leading-none">{"//"}</span>
              <span className="eai-eyebrow transition-colors group-hover:text-eai-ink group-active:text-eai-ink-soft">
                {organization?.name || "Asset Group"}
              </span>
            </Link>

            {/* Title row mirrors PageHeader: from sm up the action pins right, bottom-aligned to the title, in every view. Below sm it moves to the controls row. */}
            <div className="mt-1 flex items-end justify-between gap-4">
              <h1 className="eai-page-title min-w-0 break-words">{selectedGroup.name}</h1>

              {isSmUp && addAssetButton}
            </div>

            {selectedGroup.description && (
              <p className="eai-description-sm mt-1.5 line-clamp-2">{selectedGroup.description}</p>
            )}
          </div>
        </div>

        {/* Controls lead on the left like the other list pages' pickers; the organization badge takes the right edge */}
        <div className="flex flex-col items-start gap-3 sm:flex-row sm:flex-wrap sm:items-center sm:justify-between">
          {/* Below sm the row spans the width, with the switcher left and the round buttons pinned right; from sm up it is just the switcher and Manage Models side by side */}
          <div className="flex w-full flex-wrap items-center gap-2 sm:w-auto">
            {renderViewSwitcher()}

            <div className="ml-auto flex items-center gap-2 sm:ml-0">
              {isAdmin && (
                <button
                  onClick={() => setViewMode(viewMode === "models" ? "list" : "models")}
                  className={`eai-btn-outline eai-btn-icon-mobile ${
                    viewMode === "models" ? "border-eai-border-soft-hover text-eai-ink" : ""
                  }`}
                  type="button"
                  aria-pressed={viewMode === "models"}
                  aria-label="Manage Models"
                  title="Manage ProcessedModels"
                >
                  <LayersIcon className="h-4 w-4 shrink-0" />
                  <span className="hidden sm:inline">Manage Models</span>
                </button>
              )}

              {!isSmUp && addAssetButton}
            </div>
          </div>

          {organization && <OrganizationPreview organization={organization} />}
        </div>
      </div>
    </div>
  );

  const isFiltered = Boolean(searchValue.trim() || ownerFilter || energyModelFilter);

  const clearFilters = () => {
    setSearchValue("");
    setOwnerFilter("");
    setEnergyModelFilter("");
  };

  // The overview is the whole pane: data-page-bleed lifts the shell's measure and gutters, and the card inside carries the identity the masthead would have
  if (viewMode === "overview" && isAdmin) {
    return (
      <div data-page-bleed className="relative h-full w-full">
        <Suspense fallback={<Skeleton className="h-full w-full" radius="none" />}>
          <GroupOverviewMap
            // Keyed, so a selection made in one group is not carried into the next
            key={groupid}
            groupId={groupid}
            groupName={selectedGroup.name}
            organizationName={organization?.name}
            groupImageKey={selectedGroup.profilePictureUrl}
            assets={groupAssets || []}
            viewSwitcher={renderViewSwitcher(true)}
          />
        </Suspense>
      </div>
    );
  }

  // Only the map scrolls a region of itself against a pinned header; the rest are plain columns, so eai-page-shell owns the scroll the way it does on Home.
  const pinsViewport = viewMode === "map";

  return (
    <PageContainer fullHeight={pinsViewport}>
      <div className={pinsViewport ? "flex-1 min-h-0 overflow-hidden flex flex-col" : "w-full"}>
        <div className={pinsViewport ? "shrink-0" : ""}>{groupMasthead}</div>

        {/* Sibling of the grid, not nested in the header block above: a sticky element is released the moment its own parent scrolls past. */}
        {viewMode === "list" && (
            <>
              <FilterBar
                sticky
                searchId="group-asset-search"
                searchValue={searchValue}
                onSearchChange={setSearchValue}
                searchPlaceholder="Search by name, description, or tag"
                filters={[
                  {
                    id: "group-asset-owner",
                    label: "Owner",
                    value: ownerFilter,
                    onChange: setOwnerFilter,
                    options: ownerOptions,
                    allLabel: "Anyone",
                  },
                  ...(energyModelOptions.length > 0
                    ? [
                        {
                          id: "group-asset-model",
                          label: "Energy model",
                          value: energyModelFilter,
                          onChange: setEnergyModelFilter,
                          options: energyModelOptions,
                          allLabel: "Any",
                        },
                      ]
                    : []),
                ]}
                onClear={clearFilters}
                isFiltered={isFiltered}
              />

              <div className="eai-section-label flex items-center gap-2.5">
                <span className="eai-eyebrow">
                  {isFiltered ? `${filteredAssets.length} of ${assetCount} Assets` : `${assetCount} Assets`}
                </span>
                <span className="h-px flex-1 bg-eai-border" />
              </div>
            </>
          )}
        {viewMode === "list" ? (
            <div data-tour="group-asset-table">
              {assetCount === 0 ? (
                <div className="eai-panel flex flex-col items-center justify-center py-12 text-center">
                  <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-eai-surface-hover">
                    <GroupIcon className="h-6 w-6" />
                  </div>
                  <p className="eai-panel-title mb-1">No assets in this group yet</p>
                  <p className="eai-description-sm mb-5">
                    Add your first asset to start forecasting against it.
                  </p>
                  <button
                    onClick={handleAddAsset}
                    className="eai-btn-cta"
                    type="button"
                    disabled={!canAddAsset}
                  >
                    <PlusIcon className="h-4 w-4 shrink-0" />
                    New Asset
                  </button>
                </div>
              ) : filteredAssets.length === 0 ? (
                <div className="eai-panel flex flex-col items-center justify-center py-12 text-center">
                  <p className="eai-panel-title mb-1">No assets match</p>
                  <p className="eai-description-sm mb-5">Try a different search, or clear the filters.</p>
                  <button onClick={clearFilters} className="eai-btn-outline" type="button">
                    Clear filters
                  </button>
                </div>
              ) : (
                <AssetGrid
                  assetItems={filteredAssets}
                  organizationId={selectedGroup?.organizationId}
                  groupOwner={selectedGroup?.owner}
                  isAdmin={isAdmin}
                  currentUserId={user.permissionDetails?.id}
                />
              )}
            </div>
          ) : viewMode === "map" ? (
            /* p-0: the map is the panel's whole content, so the frame gives it the border and lift without the panel's own gutters */
            <div className="eai-panel flex-1 min-h-0 overflow-hidden p-0">
              <AssetMapView
                assetItems={assets.dataGroups[groupid]}
                assetGroup={selectedGroup}
                onAssetClick={(assetId, assetGroupId) => navigate(`/home/group/${assetGroupId}/asset/${assetId}`)}
              />
            </div>
          ) : viewMode === "models" ? (
            <div>
              <div className="eai-panel">
                <ProcessedModelManagement
                  assets={assets.dataGroups[groupid] || []}
                  assetGroup={selectedGroup}
                />
              </div>
            </div>
          ) : (
            <div>
              {/* Dashboard View — eai-page-shell already centres and pads, so no second measure here */}
              <div>
                {/* Recent Updates Section — p-0 because the accent-bar row owns the padding, overflow-hidden so that bar is clipped by the panel's rounded corner */}
                <div className="eai-panel overflow-hidden p-0">
                  <div className={`border-l-4 border-eai-cta-primary p-4 ${updatesCollapsed ? 'cursor-pointer hover:bg-eai-surface-sunken transition-colors' : ''}`}
                       onClick={updatesCollapsed ? () => setUpdatesCollapsed(false) : undefined}>
                    <div className="flex items-center justify-between mb-3">
                      <h2 className="eai-h3-title flex items-center">
                        Recent Updates
                        <span className="eai-tag-pill-sm ml-3 border-eai-success-border bg-eai-success-surface text-eai-success-text">
                          All Systems Operational
                        </span>
                      </h2>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          setUpdatesCollapsed(!updatesCollapsed);
                        }}
                        className="eai-btn-icon"
                        title={updatesCollapsed ? "Expand updates" : "Collapse updates"}
                      >
                        {updatesCollapsed ? (
                          <ChevronDownIcon className="w-4 h-4 text-eai-ink-subtle" />
                        ) : (
                          <ChevronUpIcon className="w-4 h-4 text-eai-ink-subtle" />
                        )}
                      </button>
                    </div>
                    
                    {!updatesCollapsed && (
                      <div className="space-y-2">
                      {/* Update Item 1 */}
                      <div className="border-b border-eai-border pb-2 last:border-0">
                        <div className="flex items-start">
                          <div className="w-1.5 h-1.5 bg-eai-cta-primary rounded-full mt-1.5 mr-2"></div>
                          <div className="flex-1">
                            <div className="flex items-baseline justify-between">
                              <h3 className="eai-card-title">
                                Maintenance Completed
                              </h3>
                              <span className="eai-description-sm text-xs ml-2 shrink-0">2 hours ago</span>
                            </div>
                            <p className="eai-description-sm text-xs leading-relaxed mt-0.5">
                              Scheduled maintenance on Pump Station A completed successfully. Systems running at optimal efficiency with firmware v2.1.4.
                            </p>
                          </div>
                        </div>
                      </div>

                      {/* Update Item 2 */}
                      <div className="border-b border-eai-border pb-2 last:border-0">
                        <div className="flex items-start">
                          <div className="w-1.5 h-1.5 bg-eai-teal-deep rounded-full mt-1.5 mr-2"></div>
                          <div className="flex-1">
                            <div className="flex items-baseline justify-between">
                              <h3 className="eai-card-title">
                                Performance Metrics
                              </h3>
                              <span className="eai-description-sm text-xs ml-2 shrink-0">5 hours ago</span>
                            </div>
                            <p className="eai-description-sm text-xs leading-relaxed mt-0.5">
                              Asset utilization up 12% this quarter. Predictive analytics reduced unplanned downtime by 35%.
                            </p>
                          </div>
                        </div>
                      </div>

                      {/* Update Item 3 */}
                      <div className="border-b border-eai-border pb-2 last:border-0">
                        <div className="flex items-start">
                          <div className="w-1.5 h-1.5 bg-eai-warning-text rounded-full mt-1.5 mr-2"></div>
                          <div className="flex-1">
                            <div className="flex items-baseline justify-between">
                              <h3 className="eai-card-title">
                                Inspection Scheduled
                              </h3>
                              <span className="eai-description-sm text-xs ml-2 shrink-0">Yesterday</span>
                            </div>
                            <p className="eai-description-sm text-xs leading-relaxed mt-0.5">
                              Annual safety inspection scheduled for Sept 24th at 10:00 AM. Ensure documentation is updated.
                            </p>
                          </div>
                        </div>
                      </div>

                      {/* Update Item 4 */}
                      <div className="border-b border-eai-border pb-2 last:border-0">
                        <div className="flex items-start">
                          <div className="w-1.5 h-1.5 bg-eai-cta-primary rounded-full mt-1.5 mr-2"></div>
                          <div className="flex-1">
                            <div className="flex items-baseline justify-between">
                              <h3 className="eai-card-title">
                                New Sensor Deployed
                              </h3>
                              <span className="eai-description-sm text-xs ml-2 shrink-0">2 days ago</span>
                            </div>
                            <p className="eai-description-sm text-xs leading-relaxed mt-0.5">
                              Temperature and vibration sensors installed on Asset #47. All parameters within normal ranges.
                            </p>
                          </div>
                        </div>
                      </div>
                      </div>
                    )}
                  </div>
                </div>

                {/* Parameters and Map Section */}
                <div className="mt-6 grid grid-cols-1 lg:grid-cols-3 gap-6">
                  {/* Parameters List - Left Side */}
                  <div className="eai-panel">
                    <h2 className="eai-h3-title mb-4">
                      Parameters
                    </h2>
                    <div className="space-y-2">
                      {/* Parameter items - clickable with light green background when selected */}
                      <div 
                        className={`flex items-center justify-between cursor-pointer p-3 rounded-eai-card transition-colors ${
                          selectedParams.has('waterLevel') ? 'border border-eai-success-border bg-eai-success-surface' : 'border border-transparent hover:bg-eai-surface-sunken'
                        }`}
                        onClick={() => toggleParam('waterLevel')}
                      >
                        <span className="font-inter text-eai-body-sm text-eai-ink-soft">Water Level</span>
                        <span className="eai-description-sm text-xs">+2.4m</span>
                      </div>
                      
                      <div 
                        className={`flex items-center justify-between cursor-pointer p-3 rounded-eai-card transition-colors ${
                          selectedParams.has('flowRate') ? 'border border-eai-success-border bg-eai-success-surface' : 'border border-transparent hover:bg-eai-surface-sunken'
                        }`}
                        onClick={() => toggleParam('flowRate')}
                      >
                        <span className="font-inter text-eai-body-sm text-eai-ink-soft">Flow Rate</span>
                        <span className="eai-description-sm text-xs">1,250 m³/s</span>
                      </div>
                      
                      <div 
                        className={`flex items-center justify-between cursor-pointer p-3 rounded-eai-card transition-colors ${
                          selectedParams.has('precipitation') ? 'border border-eai-success-border bg-eai-success-surface' : 'border border-transparent hover:bg-eai-surface-sunken'
                        }`}
                        onClick={() => toggleParam('precipitation')}
                      >
                        <span className="font-inter text-eai-body-sm text-eai-ink-soft">Precipitation</span>
                        <span className="eai-description-sm text-xs">12mm</span>
                      </div>
                      
                      <div 
                        className={`flex items-center justify-between cursor-pointer p-3 rounded-eai-card transition-colors ${
                          selectedParams.has('temperature') ? 'border border-eai-success-border bg-eai-success-surface' : 'border border-transparent hover:bg-eai-surface-sunken'
                        }`}
                        onClick={() => toggleParam('temperature')}
                      >
                        <span className="font-inter text-eai-body-sm text-eai-ink-soft">Temperature</span>
                        <span className="eai-description-sm text-xs">18°C</span>
                      </div>
                      
                      <div 
                        className={`flex items-center justify-between cursor-pointer p-3 rounded-eai-card transition-colors ${
                          selectedParams.has('snowDepth') ? 'border border-eai-success-border bg-eai-success-surface' : 'border border-transparent hover:bg-eai-surface-sunken'
                        }`}
                        onClick={() => toggleParam('snowDepth')}
                      >
                        <span className="font-inter text-eai-body-sm text-eai-ink-soft">Snow Depth</span>
                        <span className="eai-description-sm text-xs">45cm</span>
                      </div>
                      
                      <div 
                        className={`flex items-center justify-between cursor-pointer p-3 rounded-eai-card transition-colors ${
                          selectedParams.has('windSpeed') ? 'border border-eai-success-border bg-eai-success-surface' : 'border border-transparent hover:bg-eai-surface-sunken'
                        }`}
                        onClick={() => toggleParam('windSpeed')}
                      >
                        <span className="font-inter text-eai-body-sm text-eai-ink-soft">Wind Speed</span>
                        <span className="eai-description-sm text-xs">22 km/h</span>
                      </div>
                    </div>
                  </div>

                  {/* Map - Right Side */}
                  <div className="lg:col-span-2 eai-panel">
                    <div className="h-[640px] bg-eai-surface-hover rounded-eai-card overflow-hidden">
                      {/* Embed the AssetMapView component - only show asset names, locations, and kmz */}
                      <div className="w-full h-full">
                        <AssetMapView
                          assetItems={assets.dataGroups[groupid]}
                          isEmbedded={true}
                          showWeatherData={false}
                          showOnlyAssetData={true}
                          style={{ width: '100%', height: '100%' }}
                          onAssetClick={(assetId, assetGroupId) => navigate(`/home/group/${assetGroupId}/asset/${assetId}`)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
      </div>
    </PageContainer>
  );
};

export default GroupPage;
